export const MapState = {
	"default": 0,
	"addTreeBegin": 1,
	"addTreeSelected": 2,
	"addTreeSubmit": 3,
	"disabled": 4,
}
